<div class="overview-container">

  <!-- ADMIN DASHBOARD -->
  @if(loggedInUser) {
    <app-admin-dashboard [project]="'ALL'"></app-admin-dashboard>
  }

  <!-- SALES LEADS DASHBOARD -->
  @if(!loggedInUser) {
    <app-sales-dashboard [project]="'ALL'"></app-sales-dashboard>
  }

</div>
